/** Shared structured copy for Itria Assistant (mirrors backend chatbot-knowledge.json). */

export const CHATBOT_PRICING = {
  hourlyRateCents: 3300,
  headline: 'Our flat rate is $33 per hour, per cleaner.',
  bullets: [
    'Every cleaning type is the same price',
    'Standard, Deep, Airbnb, Move-In/Out, Post-Construction & Organization',
    'Choose the number of hours that works for your home',
    'No hidden fees',
  ],
};

export const CHATBOT_SERVICES = [
  'Standard cleaning',
  'Deep cleaning',
  'Airbnb turnover',
  'Move-in / move-out',
  'Post-construction cleaning',
  'Organization',
];

export const CHATBOT_HOW_IT_WORKS = [
  'Enter your address and home details',
  'Choose hours and pick a time',
  'Select a cleaner or send a request',
  'Pay securely and track your cleaner',
];

/** Live cancellation policy — not PRD stub (6h / 1h fee). */
export const CHATBOT_CANCELLATION_POLICY =
  'Cancel free more than 24 hours before your scheduled start. Cancellations within 24 hours incur a $33 fee. Cancellations while status is requested (no cleaner assigned yet) are free with full refund.';

export const CHATBOT_WELCOME =
  "Hi! I'm Itria Assistant. I can help you book a cleaning, explain how much it will cost, learn about our services, or answer common questions.";
